/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOrderItem = /* GraphQL */ `
  query GetOrderItem($id: ID!) {
    getOrderItem(id: $id) {
      id
      customerNumber
      email
      printManufacturer
      notificationAt
      billingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      shippingAdress {
        companyName
        addressLine1
        addressLine2
        street
        zipCode
        city
        country
        phone
      }
      status
      files {
        key
        name
      }
      furtherInfo
      furtherInfoFlowingMotifs
      furtherInfoQualityCheck
      positions {
        articleNumber
        articleName
        quantity
        productGroup
        widthByMm
        heightByMm
        White
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
      }
      chooseUpload
      deliveryDate
      uploadedDate
      createdAt
      language
      lastOpened
      manufacturerNote
      internalNote
      shippingMethod
      zollanmeldung
      activityLogs {
        items {
          id
          operation
          field
          value
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
          updatedBy
          createdAt
          updatedAt
          typename
          orderItemActivityLogsId
        }
        nextToken
      }
      lastUpdatedBy
      typename
      updatedAt
    }
  }
`;
export const listOrderItems = /* GraphQL */ `
  query ListOrderItems(
    $id: ID
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listOrderItems(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const getManufacturer = /* GraphQL */ `
  query GetManufacturer($id: ID!) {
    getManufacturer(id: $id) {
      id
      name
      email
      createdAt
      typename
      updatedAt
    }
  }
`;
export const listManufacturers = /* GraphQL */ `
  query ListManufacturers(
    $id: ID
    $filter: ModelManufacturerFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listManufacturers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        email
        createdAt
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const getActivityLog = /* GraphQL */ `
  query GetActivityLog($id: ID!) {
    getActivityLog(id: $id) {
      id
      operation
      field
      value
      positionImage {
        key
        pdfKey
        quantity
        thumbnail
        filledPositionArticleNumber
        size
        comment
        approvalStatus
        acceptedDescription
        rejectedReason
        rejectedDescription
        fullName
        files {
          key
          name
        }
      }
      updatedBy
      createdAt
      updatedAt
      typename
      orderItemActivityLogsId
    }
  }
`;
export const listActivityLogs = /* GraphQL */ `
  query ListActivityLogs(
    $id: ID
    $filter: ModelActivityLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listActivityLogs(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        operation
        field
        value
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
        updatedBy
        createdAt
        updatedAt
        typename
        orderItemActivityLogsId
      }
      nextToken
    }
  }
`;
export const listOrderItemByEmail = /* GraphQL */ `
  query ListOrderItemByEmail(
    $email: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByEmail(
      email: $email
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemByCreatedAt = /* GraphQL */ `
  query ListOrderItemByCreatedAt(
    $typename: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByCreatedAt(
      typename: $typename
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemById = /* GraphQL */ `
  query ListOrderItemById(
    $typename: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemById(
      typename: $typename
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemByStatus = /* GraphQL */ `
  query ListOrderItemByStatus(
    $typename: String!
    $status: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByStatus(
      typename: $typename
      status: $status
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemByPrintManufacturer = /* GraphQL */ `
  query ListOrderItemByPrintManufacturer(
    $typename: String!
    $printManufacturer: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByPrintManufacturer(
      typename: $typename
      printManufacturer: $printManufacturer
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemByDeliveryDate = /* GraphQL */ `
  query ListOrderItemByDeliveryDate(
    $typename: String!
    $deliveryDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByDeliveryDate(
      typename: $typename
      deliveryDate: $deliveryDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listOrderItemByUploadedDate = /* GraphQL */ `
  query ListOrderItemByUploadedDate(
    $typename: String!
    $uploadedDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderItemByUploadedDate(
      typename: $typename
      uploadedDate: $uploadedDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        email
        printManufacturer
        notificationAt
        billingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        shippingAdress {
          companyName
          addressLine1
          addressLine2
          street
          zipCode
          city
          country
          phone
        }
        status
        files {
          key
          name
        }
        furtherInfo
        furtherInfoFlowingMotifs
        furtherInfoQualityCheck
        positions {
          articleNumber
          articleName
          quantity
          productGroup
          widthByMm
          heightByMm
          White
          positionImage {
            key
            pdfKey
            quantity
            thumbnail
            filledPositionArticleNumber
            size
            comment
            approvalStatus
            acceptedDescription
            rejectedReason
            rejectedDescription
            fullName
            files {
              key
              name
            }
          }
        }
        chooseUpload
        deliveryDate
        uploadedDate
        createdAt
        language
        lastOpened
        manufacturerNote
        internalNote
        shippingMethod
        zollanmeldung
        activityLogs {
          items {
            id
            operation
            field
            value
            positionImage {
              key
              pdfKey
              quantity
              thumbnail
              filledPositionArticleNumber
              size
              comment
              approvalStatus
              acceptedDescription
              rejectedReason
              rejectedDescription
              fullName
            }
            updatedBy
            createdAt
            updatedAt
            typename
            orderItemActivityLogsId
          }
          nextToken
        }
        lastUpdatedBy
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listManufacturersByDate = /* GraphQL */ `
  query ListManufacturersByDate(
    $typename: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelManufacturerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManufacturersByDate(
      typename: $typename
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        email
        createdAt
        typename
        updatedAt
      }
      nextToken
    }
  }
`;
export const listActivityLogByCreatedAt = /* GraphQL */ `
  query ListActivityLogByCreatedAt(
    $typename: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelActivityLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivityLogByCreatedAt(
      typename: $typename
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        operation
        field
        value
        positionImage {
          key
          pdfKey
          quantity
          thumbnail
          filledPositionArticleNumber
          size
          comment
          approvalStatus
          acceptedDescription
          rejectedReason
          rejectedDescription
          fullName
          files {
            key
            name
          }
        }
        updatedBy
        createdAt
        updatedAt
        typename
        orderItemActivityLogsId
      }
      nextToken
    }
  }
`;
